import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { SessionService } from './SessionService';
import { UserService } from './UserService';
import { environment } from '../../environments/environment';
import {Observable} from "rxjs/Observable";

@Injectable()
export class BreakService {

  constructor(private http: HttpClient,
              private session: SessionService,
              private userService: UserService) {
  }

  public validationBlockByUser(data: any, callback?) {
    this.http.post(environment.api.blocktemps + '/break/overflow', data)
      .subscribe((d: any) => { callback(); },
         error => { this.session.redirectBadRequest(error);});
  }

  public getBreakOverflows(username: string, date: string, hasAvailable?) {
    return hasAvailable ? this.http.get(environment.api.blocktemps + '/break/overflow?username=' + username + '&date=' + date):
      Observable.of([]);
  }

  public getBreak(username: string, date: string) {
    // TODO: NEW URL return this.http.get(environment.api.blocktemps + '/block/details/?username=' + username + '&date=' + date).map((rs: any) => rs && rs.breakVOS);
    return this.http.get(environment.api.blocktemps + '/break/result?username=' + username + '&date=' + date);
  }

  public getCrossBreak(username: string, date: string, start: string, end: string) {
    return this.http.get(environment.api.blocktemps + `/break/overflow/cross?username=${username}&date=${date}&start=${start}&end=${end}`);
  }

}



// WEBPACK FOOTER //
// ./src/app/service/break.service.ts